import { createContext, useMemo, useState } from 'react';

import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const ColorModeContext = createContext({
  mode: 'light',
  toggle: () => {},
});

// a választott téma böngészőnként megmarad, alapból a rendszerbeállítást követjük
const THEME_KEY = 'tema';
const loadChoice = () => {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null;
  }
};

function ThemeRoot({ children }) {
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const [choice, setChoice] = useState(loadChoice);
  const mode = choice || (prefersDark ? 'dark' : 'light');

  const colorMode = useMemo(
    () => ({
      mode,
      toggle: () => {
        const next = mode === 'dark' ? 'light' : 'dark';
        setChoice(next);
        try {
          localStorage.setItem(THEME_KEY, next);
        } catch {}
      },
    }),
    [mode]
  );

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === 'dark'
            ? { background: { default: '#0d0d0d', paper: '#1a1a19' } }
            : {}),
        },
        components: {
          // sötétben ne világosodjon a Paper az elevation miatt
          MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <GlobalStyles
          styles={{
            ':root': { colorScheme: mode },
            body: {
              backgroundColor: theme.palette.background.default,
              color: theme.palette.text.primary,
            },
          }}
        />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default ThemeRoot;
